import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames/bind";
import styles from "./ModalShowUser.module.css";
import { HeaderModal, Pagination, Toast } from "../../../../components";
import NameCol from "../../../../components/NameCol";
import { notificationApi } from "../../../../services/api/notificationApi";
import Nodata from "../../../History/NoData/Nodata";
import { sorterArray } from "../../../../utils";

const cx = classNames.bind(styles);
const ModalShowUser = ({ onClose, typeNotification, title }) => {
    const [users, setUsers] = useState([])
    const [method, setMethod] = useState()
    const [dataTable, setDataTable] = useState();
    const [toggleSort, setToggleSort] = useState(false);
    const refModal = useRef(null);
    useEffect(() => {
        const handleGetUser = async () => {
            try {
                const res = await notificationApi.getUserNotification(typeNotification)
                setUsers(res)
            }
            catch {
                Toast.open("Lấy dang sách người dùng không thành công", "danger")
            }
        }
        handleGetUser()
    }, [typeNotification])


    useEffect(() => {
        const newData = users.length > 0 ? [...users] : null
        if (newData && method?.length > 0) {
            switch (toggleSort) {
                case 'up':
                    const dataSortUp = sorterArray(newData, method)
                    setDataTable(dataSortUp)
                    break;
                case 'down':
                    const dataSortDown = sorterArray(newData, method)
                    setDataTable(dataSortDown.reverse())
                    break;
                default:
                    setDataTable(newData)
                    break;
            }
        } else {
            setDataTable(newData)
        }
    }, [users, toggleSort, method])

    const handleSort = (type, method) => {
        if (type !== toggleSort) {
            setToggleSort(type)
            setMethod(method)
        } else {
            setToggleSort(false)
            setMethod('')
        }
    }

    useEffect(() => {
        const handleClickOutSide = (e) => {
            if(e.target === refModal.current) {
                onClose();
            }
        }
        document.addEventListener('click', handleClickOutSide);
        return () => document.removeEventListener('click', handleClickOutSide);
    }, [])
    return (
        <div className={cx("container")} ref={refModal}>
            <div className={cx("content")}>
                <HeaderModal onClose={onClose} title={title} />
                <div className={cx("table")}>
                    <table className={cx('table-notification')}>
                        <thead>
                            <tr>
                                <th>STT</th>
                                <th>
                                    <NameCol active={method} title={'Tên tài khoản'} handleSort={handleSort} method={'username'} />
                                </th>
                                <th>
                                    Telegram
                                </th>
                                <th>
                                    Email
                                </th>
                                <th>
                                    Trình duyệt
                                </th>

                            </tr>
                        </thead>
                        <tbody className={cx('body-table')}>
                            {dataTable && dataTable?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.username}</td>
                                        <td className={cx(item?.active.some(item => item.METHOD_DETAIL === "Telegram") ? "on" : "off")}>{item?.active.some(item => item.METHOD_DETAIL === "Telegram") ? "Bật" : "Tắt"}</td>
                                        <td className={cx(item?.active.some(item => item.METHOD_DETAIL === "Gmail") ? "on" : "off")}>{item?.active.some(item => item.METHOD_DETAIL === "Gmail") ? "Bật" : "Tắt"}</td>
                                        <td className={cx(item?.active.some(item => item.METHOD_DETAIL === "Trình duyệt") ? "on" : "off")}>{item?.active.some(item => item.METHOD_DETAIL === "Trình duyệt") ? "Bật" : "Tắt"}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                {
                    users.length > 0 ? <div className={cx("pagination")}>
                        <Pagination currentPage={1} pages={1} />
                    </div> : <Nodata />
                }
            </div>
        </div>
    );
};

export default ModalShowUser;
